import {useMutation, useQueryClient} from "@tanstack/react-query";
import { editNewCategory } from '../../../../store/api';

export const useEditCategory = ({ slug }) => {
    const queryClient = useQueryClient();

    return useMutation(['editCurrentCategory'], ({ category, archived = false }) => editNewCategory(category, archived), {
        onSuccess: async () => {
            await queryClient.invalidateQueries(['menu-categories', slug]);
        },
    });
}
